export default {
  path: "/main/product/goods",
  name: "Goods",
  component: () => import("@/views/main/Product/Goods/goods.vue"),
  children: []
};
